import {Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {UiService} from "../../services/ui.service";
import {Subscription} from "rxjs";
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";
import {CookieService} from "ngx-cookie-service";
import {constants} from "../../constants";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild("menuTrigger") menuTrigger: ElementRef;
  @ViewChild("menuContainer") menuContainer: ElementRef;
  @ViewChild("mobileMenuTrigger") mobileMenuTrigger: ElementRef;
  @ViewChild("mobileMenuContainer") mobileMenuContainer: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;

  headerOpened: boolean;
  menuOpened: boolean;
  searchText: string;
  appUrl: string = environment.appUrl;

  isLoggedIn: boolean;
  msisdn: string;

  subscription: Subscription;

  privetSubscription: boolean;

  showCookieBanner: boolean;

  private readonly COOKIE_ACCEPT_KEY = 'cookie-accepted';

  blockedSymbols = new Set(constants.forbiddenChars);
  blackListPattern = constants.blackListPattern;

  constructor(private readonly uiService: UiService,
              private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService,
              private readonly cookieService: CookieService,
              private readonly renderer: Renderer2) {
    this.headerOpened = false;
    this.menuOpened = false;
    this.searchText = '';

    this.isLoggedIn = false;
    this.msisdn = null;

    this.subscription = new Subscription();

    this.privetSubscription = false;

    this.showCookieBanner = false;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.uiService.headerOpened.subscribe(value => {
        this.headerOpened = value;
      })
    );

    this.subscription.add(
      this.uiService.menuOpened.subscribe(value => {
        this.menuOpened = value;
      })
    );

    this.subscription.add(
      this.subscriberService.msisdn.subscribe(value => {
        this.isLoggedIn = !!value;
        this.msisdn = value;
      })
    );

    this.subscription.add(
      this.subscriberService.subscriber.subscribe(subscriber => {
        if (subscriber) {
          this.privetSubscription = subscriber.activeSubscription;
        }
      }))

    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.menuOpened && !this.menuTrigger?.nativeElement.contains(e.target) && !this.menuContainer?.nativeElement.contains(e.target) &&
        !this.mobileMenuTrigger?.nativeElement.contains(e.target) && !this.mobileMenuContainer?.nativeElement.contains(e.target)) {
        this.uiService.menuChanged(false);
      }
    });

    this.showCookieBanner = !this.cookieService.check(this.COOKIE_ACCEPT_KEY);
  }

  openHeader(): void {
    if (!this.headerOpened) {
      this.uiService.headerChanged(true);
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
        window.scrollTo({top: 0, behavior: "smooth"});
      }, 0);
    }
  }

  closeHeader(): void {
    if (this.headerOpened) {
      this.uiService.headerChanged(false);
    }
  }

  toggleMenu(): void {
    this.uiService.menuChanged(!this.menuOpened);
  }

  clearSearch(): void {
    this.searchText = '';
    this.search();
  }

  search(): void {
    this.uiService.searchTextChanged(this.searchText);
  }

  openLogin(): void {
    this.modalsService.showLogin();
  }

  openLogout(): void {
    this.modalsService.showLogout();
  }

  openCorpLogin() {
    this.cookieService.set('corporate', null, 1, '/', null, null, "Strict");
    location.assign('/authorized');
  }

  acceptCookies(): void {
    this.cookieService.set(this.COOKIE_ACCEPT_KEY, 'true', 365, '/', null, null, 'Strict');
    this.showCookieBanner = false;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onInputChange(event: Event): void {
    let value = (event.target as HTMLInputElement).value;
    this.searchText = value.replace(this.blackListPattern, '');
  }

  onKeyDown(event: KeyboardEvent): void {
    let key = event.key;

    if (this.blockedSymbols.has(key)) {
      event.preventDefault();
    }
  }
}
